import { NumericFormat as NumberFormat } from 'react-number-format';
import { style, stylesheet } from 'typestyle';
import { Hide } from '@src/components/Hide';
import { Loader } from '@src/components/Loader';

interface HideStoriesControlProps {
  isFetchingStories?: boolean;
  setIsFetchingStories?: (val: boolean) => void;
}

interface SearchModeControlsProps {
  isExactMode: boolean;
  estimatedCount: number;
  exactCount: number;
  isFetching?: boolean;
  onSearchModeChange: (exact: boolean) => void;
}

export function HideStoriesControl(props: HideStoriesControlProps) {
  return (
    <button
      className={buttonClass}
      style={{ display: 'flex', alignItems: 'center', gap: 6, marginRight: 12 }}
      tabIndex={-1}
      type='button'
      onClick={() => props.setIsFetchingStories?.(!props.isFetchingStories)}
    >
      <input
        type='checkbox'
        checked={!props.isFetchingStories}
        readOnly
        style={{ accentColor: 'gray', margin: 0 }}
      />
      Hide stories
    </button>
  );
}

export function SearchModeControls(props: SearchModeControlsProps) {
  return (
    <div className={resultsClass}>
      <div className={resultsLineClass}>
        <Hide hide={!props.isFetching}>
          <div className={sheet.fetching}>
            <Loader size={10} />
          </div>
        </Hide>
        <span className={estimateDescClass}>
          {lang.estimateDescription}
        </span>
        <button
          className={buttonClass}
          onClick={() => props.onSearchModeChange(false)}
          disabled={!props.isExactMode}
          style={{ color: !props.isExactMode ? 'white' : undefined }}
        >
          <NumberFormat
            value={props.estimatedCount}
            displayType='text'
            thousandSeparator
            className={countClass}
          />
          {window.T('collect.filterright.results')}
        </button>
      </div>
      <button
        className={buttonClass}
        onClick={() => props.onSearchModeChange(true)}
        disabled={!!props.isExactMode}
        style={{ color: props.isExactMode ? 'white' : undefined }}
      >
        <NumberFormat
          value={props.exactCount}
          displayType='text'
          thousandSeparator
          className={countClass}
        />
        {window.T('collect.filterright.exactresults')}
      </button>
    </div>
  );
}

const lang = {
  estimateDescription: 'Estimated media matches: ',
};

const sheet = stylesheet({
  fetching: {
    marginRight: 10,
    display: 'inline-block',
  },
});

const countClass = style({
  marginRight: 4,
});

const buttonClass = style({
  fontSize: 13,
  textAlign: 'right',
  background: 'none',
  border: 'none',
  outline: 'none',
  color: 'gray',
  fontWeight: 'bold',
  cursor: 'pointer',
  padding: 0,
  $nest: {
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:disabled': {
      cursor: 'default',
      textDecoration: 'none',
    },
  },
});

const estimateDescClass = style({
  marginRight: 4,
  fontSize: 12,
  verticalAlign: 'top',
});

const resultsClass = style({
  color: 'gray',
  display: 'flex',
  flexDirection: 'column',
});

const resultsLineClass = style({
  lineHeight: '10px',
  textAlign: 'right',
});